<template>
  <div class="lessonKind__container">
    <label v-for="(name, code) of types" :key="code" class="checkbox">
      <input
        type="checkbox"
        v-model="selected"
        :value="code"
      >
      {{ name }}
    </label>
  </div>
</template>

<script lang="ts">
import { scheduleType, ScheduleTypes } from '@/store/schedules/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ScheduleTypesInput extends Vue {
  @Prop() value!: scheduleType[]

  private types = ScheduleTypes

  private get selected(): scheduleType[] {
    return this.value
  }

  private set selected(selectedTypes: scheduleType[]) {
    this.$emit('input', selectedTypes)
  }
}
</script>

<style scoped>
.lessonKind__container {
  display: flex;
  flex-wrap: wrap;
}

input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  display:flex;
  width:50%;
  height: 40px;
}
</style>
